// DialogTemplateMailSetting Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import InputTag from '../../../common/form/input_tag/input_tag.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import Select from '../../../common/form/select/select.jsx'
import AddressSelect from '../../../common/form/address_select/address_select.jsx'

class DialogTemplateMailSetting extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      showError: false,
      dataDate: null,
      bTagFocus: false,
      bEmailErr: false,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null,
      showReadOnly: false
    }

    this.data = {
      files: [],
      template: []
    }

    this._references = {
      inputTagMail: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      onDownload: PropTypes.func,
      downloadUrl: PropTypes.string,
      mailSuggestions: PropTypes.array,
      showWithoutContext: PropTypes.bool,
      showMultiAttachments: PropTypes.bool,
      isQuickbookConnected: PropTypes.bool,
      onClose: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      onDownload: null,
      downloadUrl: '',
      mailSuggestions: [],
      showWithoutContext: false,
      showMultiAttachments: false,
      isQuickbookConnected: false,
      onClose: null
    }
  }

  show (template, bEmailErr) {
    FabButtonManager.setVisible(false)
    if (template) {
      this.data.files = []
      if (template.mailSetting) {
        template.toEmails = template.mailSetting.toEmails
          ? template.mailSetting.toEmails
          : []
        template.subject = template.mailSetting.subject
          ? template.mailSetting.subject
          : ''
        template.content = template.mailSetting.content
          ? template.mailSetting.content
          : ''

        this.data.files = template.mailSetting.files
          ? template.mailSetting.files
          : []
      }

      const defaultPersonId =
        template.contactPersonOptions.length > 0
          ? template.contactPersonOptions[0].value
          : ''
      this.setState({
        contactPersonOptions: template.contactPersonOptions,
        addressOptions: template.addressOptions ? template.addressOptions : [],
        addresses: template.addresses ? template.addresses : []
      })

      template.contactPersonId =
        template.contactPerson && template.contactPerson.email
          ? template.contactPerson.email
          : defaultPersonId
      template.address = template.contactAddress

      this.data.template = template
    }

    this.setState({
      active: true,
      dataDate: new Date(),
      showError: !this.props.isQuickbookConnected && bEmailErr,
      bEmailErr: bEmailErr
    })
  }

  hide () {
    FabButtonManager.setVisible(true)

    this.data.template.toEmails = []
    this.data.template.files = []

    this.setState({
      active: false,
      showError: false,
      dataDate: null,
      bEmailErr: false,
      bTagFocus: false
    })
  }

  _onUpdateToMails (toEmails) {
    this.data.template.toEmails = toEmails
    this.setState({ bEmailErr: false, dataDate: new Date() })
  }

  _onUpdateFiles (files) {
    this.data.files = files || []
  }

  _onClickTag () {
    if (this._references.inputTagMail.current) {
      this._references.inputTagMail.current.focus()
    }

    this.setState({ bTagFocus: true })
  }

  _onFocusInput () {
    this.setState({ bTagFocus: false })
  }

  isActive () {
    return this.state.active
  }

  render () {
    const { isQuickbookConnected } = this.props
    const template = this.data.template
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    const tagClassName = `formcol formcol_tag${
      this.state.bTagFocus ? ' active' : ''
    }`
    const toTagBtmCls = this.state.bEmailErr
      ? 'tagbottom haserror'
      : 'tagbottom'

    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        type='medium'
      >
        <div className='dialog-form estimatemail-form invoicetemplatemail-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='invoicetemplate.form.mailSettingDialogTitle' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='estimate.form.emailDialogErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='referenceNo'
                          label='invoice.form.labelPoNumber'
                          size={10}
                          maxLength={100}
                          styleDotted
                          validations={isQuickbookConnected ? [] : ['required']}
                          value={template.referenceNo}
                          onChange={this._onChangeInput.bind(
                            this,
                            'referenceNo'
                          )}
                        />
                      </div>
                    </div>
                    {this.state.contactPersonOptions && this.state.contactPersonOptions.length > 0 && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.state.contactPersonOptions}
                            name='contactPersonId'
                            className='form-dropdown'
                            label='invoice.form.labelContactPerson'
                            value={template.contactPersonId}
                            onChange={this._onChangeContactPerson.bind(
                              this,
                              'contactPersonId'
                            )}
                          />
                        </div>
                      </div>
                    )}
                    {!isQuickbookConnected && (
                      <div className='formrow formrowtag'>
                        <div className='formcol formcollabel'>
                          <IntlMessage ident='invoice.form.labelTo' />
                        </div>
                        <div className='formcol formcoltag'>
                          <div
                            className={tagClassName}
                            onClick={this._onClickTag.bind(this)}
                          >
                            <InputTag
                              ref={this._references.inputTagMail}
                              tags={template.toEmails}
                              bAlt
                              tagSuggestions={this.props.mailSuggestions}
                              onUpdateTags={this._onUpdateToMails.bind(this)}
                              delimiterKeys={[32, 9, 13]}
                              withoutContext={this.props.showWithoutContext}
                            />
                            <span className={toTagBtmCls} />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className='formrow'>
                      <div className='formcol2'>
                        <AddressSelect
                          addressOptions={this.state.addressOptions}
                          address={template.address}
                          onSelectAddress={this._onSelectAddress.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              canHover={false}
              title='invoicetemplate.form.mailSettingSave'
              onClick={this._onFormSubmit.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onSelectAddress (addressType) {
    let address = null

    if (this.state.addresses && this.state.addresses.length > 0) {
      address = _.find(
        this.state.addresses,
        address => address.type.toLowerCase() === addressType
      )
    }
    this.data.template.address = address

    this.setState({ dataDate: new Date() })
  }

  _onFormSubmit (ev) {
    ev.preventDefault()
    let noErrors = 0
    let bEmailErr = false

    if (
      this._references.inputTagMail.current &&
      this.data.template.toEmails.length === 0
    ) {
      noErrors++
      bEmailErr = true
    }

    if (noErrors === 0) {
      let contactPerson = null
      if (
        this.data.template.contactPersonId &&
        this.state.contactPersonOptions &&
        this.state.contactPersonOptions.length > 0
      ) {
        contactPerson = _.find(this.state.contactPersonOptions, contact => {
          return contact.value === this.data.template.contactPersonId
        })
      }

      if (contactPerson) {
        this.data.template.contactPerson = {
          name: contactPerson.label,
          email: contactPerson.value
        }
      }

      const prevUploadedFiles = this.data.template.mailSetting
        ? this.data.template.mailSetting.files
        : []
      this.data.template.files = []
      this.data.files.map(fileObj => {
        if (
          _.findIndex(
            prevUploadedFiles,
            prevFile => prevFile.fileName === fileObj.fileName
          ) < 0
        ) {
          this.data.template.files.push(fileObj)
        }
      })

      if (this.props.onSubmit) {
        this.props.onSubmit(this.data.template)
      }
    } else {
      this.setState({ showError: true, bEmailErr: bEmailErr })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _onClickAttachment (ev) {
    ev.preventDefault()

    if (this.props.onDownload) {
      this.props.onDownload(this.data.template.id)
    }
  }

  _onChangeInput (name, value) {
    this.data.template[name] = value
    this.setState({ dataDate: new Date() })
  }

  _onChangeContactPerson (name, value) {
    const { template } = this.data
    const { contactPersonOptions } = this.state

    template[name] = value

    const contactPerson = _.find(
      contactPersonOptions,
      options => options.label === value
    )
    if (contactPerson && contactPerson.obj.email) {
      if (
        _.findIndex(
          template.toEmails,
          obj => obj.id === contactPerson.obj.email
        ) < 0
      ) {
        template.toEmails.push({
          id: contactPerson.obj.email,
          text: contactPerson.obj.email
        })
      }
    }
    this.setState({ dataDate: new Date() })
  }

  _onChangeUpload (files) {
    this.data.template.files = files
    this.setState({ dataDate: new Date() })
  }
}

export default DialogTemplateMailSetting
